<template>
  <div class="main_right">
    <div class="Box">
      <div class="testpage">
        <iframe
          class="questionnaire-iframe"
          src="https://survey.ideaigc.com/vm/rnYjDw5.aspx"
          frameborder="0"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'questionnaire'
}
</script>

<style lang="scss" scoped>
.main_right {
  width: calc(100% - 10.5vw);
  height: 100%;
  float: left;
  box-sizing: border-box;
  padding: 0 2%;
  position: relative;

  .Box {
    width: 100%;
    height: 100%;
    box-shadow: 0px 0px 16px 0px rgba(89, 144, 255, 0.3);
    border-radius: 10px;
    padding: 2%;
    box-sizing: border-box;
    position: relative;
  }

  .testpage {
    width: 100%;
    height: 100%;
    position: relative;

    p:nth-child(1) {
      width: 100%;
      height: 2.5vw;
      text-align: center;
      position: relative;
      color: #333;
      font-size: 1.5vw;
      line-height: 2.5vw;
    }

    .questionnaire-iframe {
      display: block;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      border: none;
    }
  }
}

/* ========== 手机端适配样式 ========== */
@media screen and (max-width: 768px) {
  .main_right {
    width: calc(100% - 80px);
    padding: 0 10px;

    .Box {
      padding: 12px 10px;
      display: flex;
      flex-direction: column;
      height: auto;
      min-height: 100%;
    }

    .testpage {
      flex: 1;
      min-height: 0;
      display: flex;
      flex-direction: column;
      width: 100%;
      overflow: hidden;

      p:nth-child(1) {
        height: 36px;
        line-height: 36px;
        font-size: 14px;
        flex-shrink: 0;
        text-align: center;
      }

      .questionnaire-iframe {
        position: relative;
        top: auto;
        bottom: auto;
        flex: 1;
        width: 100%;
        min-height: 400px;
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .main_right {
    width: calc(100% - 65px);
    padding: 0 8px;

    .Box {
      padding: 10px 8px;
    }

    .testpage p:nth-child(1) {
      height: 32px;
      line-height: 32px;
      font-size: 13px;
    }
  }
}
</style>
